<template>
    <div class="py-4 container-fluid">
        <div class="custom-header font-weight-bold text-left">Reservation List</div>
        <div class="card mb-4">
            <div class="card-header">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                          <div class="col">
                            <div class="row">
                              <div class="col-md-6 text-left">
                                <label for="crewValue" class="font-weight-bold">Search Crew Name:</label>
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                            type="button"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                      <i class="fa fa-search pr-2"></i>By {{key}}:
                                    </button>

                                    <div class="dropdown-menu">
                                      <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':reservationParams.searchKey == 'all'}">All</a>
                                      <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':reservationParams.searchKey == 'last_name'}">LastName</a>
                                      <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':reservationParams.searchKey == 'first_name'}">FirstName</a>
                                      <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':reservationParams.searchKey == 'middle_name'}">MiddleName</a>
                                      <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':reservationParams.searchKey == 'rank'}">Rank</a>
                                      <a class="dropdown-item" href="#" @click="setKey('crewipn')" :class="{'active':reservationParams.searchKey == 'crewipn'}">CrewIPN</a>
                                      <!--  <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':searchKey == 'rank'}">Rank</a>  -->
                                    </div>
                                  </div>

                                  <!--                                            <input type="text"-->
                                  <!--                                                   class="form-control small"-->
                                  <!--                                                   aria-label="Text input with dropdown button">-->
                                  <input type="text"
                                         id="crewValue"
                                         class="form-control form-control-sm"
                                         v-model="reservationParams.searchValue"
                                         v-on:input="searchCrew(1)"
                                         :placeholder="keyPlaceHolder"
                                         aria-label="Text input with dropdown button">
                                </div>
                              </div>

                              <div class="col-md-2 text-left">
                                <label for="rsvStatus" class="font-weight-bold">Status :</label>
                                <select name="rsvStatus" id="rsvStatus" class=" custom-select custom-select-sm" v-on:change="setStatus" v-model="reservationParams.status">
                                  <option value="">All</option>
                                  <option v-for="(status,index) in reservationStatus" :key="index" :value="index+1">
                                    {{status[index]}}
                                  </option>
                                </select>
                              </div>

                              <div class="col-md-2 text-left">
                                <label for="displayCounts" class="font-weight-bold">Records:</label>
                                <select class="custom-select custom-select-sm" name="displayCounts" id="displayCounts" v-model="reservationParams.count" v-on:change="setRecords">
                                  <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === reservationParams.count">
                                    {{count}} records
                                  </option>
                                </select>
                              </div>

                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="text-left">
                    <small> {{`${reservationPagination.from} - ${reservationPagination.to} of ${reservationPagination.total}`}}</small>
                </div>
                <nav aria-label="..." class="pt-0">
                    <ul class="pagination pagination-sm">
                        <li class="page-item" :class="{ 'disabled': reservationPagination.currentPage === 1}">
                            <button class="page-link" @click="setPage(1)">
                                <font-awesome-icon icon="step-backward"/>
                                First
                            </button>
                        </li>

                        <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === reservationPagination.currentPage }">
                            <button class="page-link" @click="setPage(page)">{{ page }}</button>
                        </li>

                        <li class="page-item" :class="{ 'disabled': reservationPagination.currentPage === reservationPagination.lastPage}">
                            <button class="page-link" @click="setPage(reservationPagination.lastPage)">
                                Last
                                <font-awesome-icon icon="step-forward"/>
                            </button>
                        </li>
                    </ul>
                </nav>
                <div class="table-responsive-lg">
                    <table class="table table-bordered p-0" width="100%" cellspacing="0">
                        <thead>
                            <button class="btn btn-sm tnkc-secondary" v-on:click="searchCrew" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                                <font-awesome-icon icon="undo"/>
                            </button>
                        </thead>
                        <thead>
                            <tr class="bg-light">
                                <th scope="col" class="p-1 text-center">#</th>
                                <th scope="col" class="p-1">
                                    Batch No.
                                </th>
                                <th scope="col" class="p-1">Rank</th>
                                <th scope="col" class="p-1">Crew Name</th>
                                <th scope="col" class="p-1">Check In</th>
                                <th scope="col" class="p-1">Check Out</th>
                                <th scope="col" class="p-1" colspan="2">w/ PCR Test</th>
                                <th scope="col" class="p-1">Endorsed By</th>
                                <th scope="col" class="p-1">Remarks</th>
                                <th scope="col" class="p-1">Status</th>
                                <th scope="col" class="p-1 vert-aligned">Action</th><!-- todo for sir AC only  -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(reserve,index) in reservations" :key="index">
                            <th scope="row" class="p-1 align-middle">{{index+1}}</th>
                            <td class="p-1 align-middle">
                                <small>{{reserve.batch_no}}</small>
                            </td>
                            <td class="p-1 align-middle">{{reserve.rank}}</td>
                            <td class="p-1 align-middle text-left">
                                <button class="btn btn-xsm" v-on:click="viewProfile(reserve.crew_id)" title="Click to view profile">
                                    <u>{{reserve.crew}}</u>
                                </button>
                            </td>
                            <td class="p-1 align-middle">
                                <sup v-if="reserve.is_booked">
                                    <font-awesome-icon icon="bookmark"/>
                                </sup>
                                {{reserve.check_in | moment('D MMM YYYY')}}
                            </td>
                            <td class="p-1 align-middle">
                                <sup v-if="reserve.is_booked">
                                    <font-awesome-icon icon="bookmark"/>
                                </sup>
                                <sup v-if="reserve.extend_date" class="ml-1">
                                    <font-awesome-icon icon="arrows-alt-h"/>
                                </sup>
                                {{reserve.check_out | moment('D MMM YYYY')}}
                            </td>
                            <td class="p-1 align-middle">
                                <input class=" position-static"
                                       type="checkbox"
                                       id="crewId2"
                                       aria-label="PCRTest"
                                       :checked="reserve.has_file"
                                       :disabled="true">
                            </td>
                            <td class="p-1 align-middle">
                                <span v-if="reserve.pcr_remain_days >= 0" class="small font-weight-bold">
                                    {{reserve.pcr_remain_days ? `${reserve.pcr_remain_days}`+'d valid' : '----'}}
                                </span>
                            </td>
                            <td class="p-1 text-left">{{titleCase(reserve.endorsed_by)}}</td>
                            <td class="p-1 align-middle">
                                <button class="btn btn-sm btn-light"
                                        data-toggle="modal"
                                        data-target="#remarksModal"
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        v-on:click="reservation_remarks(reserve.crew_reservation_id)">
                                    <font-awesome-icon icon="comments"/>
                                    <sup class="ml-1">{{reserve.remarks_count}}</sup>
                                </button>
                            </td>
                            <td class="p-1 align-middle" v-bind:class="bookedExpired(reserve)">{{reserve.status === 'Approved' ? 'For Booking' : reserve.status}}</td>

                            <td class="p-1 align-middle">
                                <button class="btn btn-xsm tnkc-primary mr-1"
                                        data-toggle="modal"
                                        data-target="#reservationDetails"
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        v-on:click="crew_endorse_details(reserve.crew_reservation_id)">
                                    <font-awesome-icon icon="eye"/>
                                 <small class="font-weight-bold ml-1">View</small>
                                </button>

                                <button class="btn btn-xsm tnkc-success mr-1"
                                        data-toggle="modal"
                                        data-target="#bookingModal"
                                        data-backdrop="static"
                                        data-keyboard="false"
                                        v-if="!reserve.is_booked"
                                        v-on:click="booked_dtls(reserve.crew_reservation_id)">
                                    <font-awesome-icon icon="book"/>
                                   <small class="font-weight-bold ml-1">Book</small>
                                </button>

                                <button class="btn btn-xsm tnkc-danger mr-1" v-on:click="setRemoveReservation(reserve)"  v-if="!reserve.is_booked"
                                        data-toggle="modal"
                                        data-target="#actionRemarks"
                                        data-backdrop="static"
                                        data-keyboard="false">
                                    <font-awesome-icon icon="times"/>
                                   <small class="font-weight-bold ml-1">Remove</small>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>

        </div>

        <!-- remarks upon remove. -->
        <div class="modal fade" id="actionRemarks" tabindex="-1" role="dialog" aria-labelledby="actionRemarksTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="actionRemarksTitle">Add Remarks</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="clearRemarks">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group mt-1">
                            <textarea class="form-control" id="removeRemarks" v-model="newRemarks.remarks" style="height: 100px; resize: none;" rows="3"  @keydown="limiteTextRemarks('removeRemarks','countdown2',200)"></textarea>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn tnkc-secondary" data-dismiss="modal">
                            <font-awesome-icon icon="times"/>
                            Close
                        </button>
                        <button type="button" class="btn tnkc-danger" v-on:click="remove_reservation">
                            <font-awesome-icon icon="times"/>
                            Remove
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <booking-modal
                :search="searchCrew"
                :reservation_id="reservationId"
                :defaultCheckIn="reservDtls.endorsed_check_in"
                :defaultCheckOut="reservDtls.endorsed_check_out"/>

        <reservation-dtls/>

        <remarks-modal :search="searchCrew"/>

    </div>
</template>

<script>
  // import BatchBookApproval from '@/components/crew-reservation/_modal/BatchBookApproval';
  import BookePerBatch from './_modals/bookPerBatchModal';
  import {mapActions, mapGetters} from 'vuex';
  import ReservationDtls from './_modals/reservationDtlsModal';
  import BookingModal from './_modals/bookingModal';
  import RemarksModal from './_modals/remarksModal';
  import {appMixins} from '../../mixins/app.mixins';

  export default {
    name: 'CrewRrv_details',
    mixins: [appMixins],
    components: {
      BookePerBatch,
      ReservationDtls,
      // BatchBookApproval,
      RemarksModal,
      BookingModal
    },

    data() {
      return {
        key: '',
        keyPlaceHolder: '',
        displayCounts: [2,10, 15, 20, 30, 50, 100, 200],
        withPCR: true,

        crewReserve: {},

        reservationId: 0,

        sorting : false,

        sList : {
          sortBatch: null,
          sortCheckIn: null,
          sortCheckOut: null,
          sortDays: null,
        },

        //+1 for index value
        reservationStatus: [
          {0: 'For Booking'},
          {1: 'Booked'},
          {2: 'Extended'},
          {3: 'Checked In'},
          {4: 'Checked Out'},
          {5: 'Over-Stay'},
          {6: 'Cancelled'},
        ]
      };
    },

    methods: {
      ...mapActions(
          [
              'getCrewForReservation','getCrewReservationRemarks','getReservationDetails',
              'setNullReservations','setNullReservation','getHotelKeyDetails','setNullHotels',
              'reservationKeyDetails','setPaginationNull','removeReservation','setNullNewRemark',
              'setParamsNull','setReservationParamsNull'
          ]
      ),

      //key
      setKey(obj){
        this.reservationParams.searchKey = obj;
        this.searchCrew();
        this.searchBy();
      },

      //page
      setPage(page){
        this.reservationPagination.currentPage = page;
        this.searchCrew();
      },

      setRecords(e){
        this.reservationParams.count = parseInt(e.target.value,10);
        this.searchCrew(1);
      },

      searchBy() {
        switch (this.reservationParams.searchKey) {
          case 'all':
            this.key = 'All';
            this.keyPlaceHolder = 'Search here ...';
            break;

          case 'last_name':
            this.key = 'LastName';
            this.keyPlaceHolder = 'Search Last Name here ...';
            break;

          case 'first_name':
            this.key = 'FirstName';
            this.keyPlaceHolder = 'Search First Name here ...';
            break;

          case 'middle_name':
            this.key = 'MiddleName';
            this.keyPlaceHolder = 'Search Middle Name here ...';
            break;

          case 'crewipn':
            this.key = 'CrewIPN';
            this.keyPlaceHolder = 'Search CrewIPN here ...';
            break;

          case 'rank':
            this.key = 'Rank';
            this.keyPlaceHolder = 'Search CrewRank here ...';
            break;
        }
      },

      sortByData(sortKey, orderBy) {
        const endorseList = this.reservations;
        this.sorting = !this.sorting;
        endorseList.sort((a, b) => {
          let compare = 0;
          if (orderBy == true) {
            if (a[sortKey] < b[sortKey]) {
              compare = 1;
            } else if (b[sortKey] < a[sortKey]) {
              compare = -1;
            }
            return compare;

          } else if (orderBy == false) {
            if (a[sortKey] > b[sortKey]) {
              compare = 1;
            } else if (b[sortKey] > a[sortKey]) {
              compare = -1;
            }
            return compare;
          }
        });
      },

      //todo worked on sorting ,
      sortByBatch(key, sorting) {
        this.sList.sortBatch = this.sortFlag(this.sList.sortBatch);
        this.sortByData(key, sorting);
      },

      sortByCheckIn(key, sorting) {
        this.sList.sortCheckIn = this.sortFlag(this.sList.sortCheckIn);
        this.sortByData(key, sorting);
      },

      sortByCheckOut(key, sorting) {
        this.sList.sortCheckOut = this.sortFlag(this.sList.sortCheckOut);
        this.sortByData(key, sorting);
      },

      async searchCrew(initializePage = null){
        let page = (initializePage) ? initializePage : this.reservationPagination.currentPage;
        this.reservationParams.page = page;
        await this.getCrewForReservation(this.reservationParams);
      },

      crew_endorse_details(id){
        this.getReservationDetails({id : id});
      },

      booked_dtls(id){
        this.reservationId = id;
        this.reservationKeyDetails({crew_reservation_id : id});
      },

      reservation_remarks(id){
        this.newRemarks.crew_reservation_id = id;
        this.getCrewReservationRemarks({id : id});
      },

      setRemoveReservation(obj){
        this.reservationId = obj.crew_reservation_id;
      },

      viewProfile(id) {
        this.$router.push({name: 'CrewProfile', params: {id: id}});
      },


      clearRemarks(){
        this.setNullNewRemark();
      },

      async remove_reservation(){
        if(await this.questionAlert('Are you sure you want to remove / cancel this reservation?')){
          const params = {
            crew_reservation_id : this.reservationId,
            remarks : this.newRemarks,
          }
          this.removeReservation(params).then((res)=>{
            if(res == true){
              this.setNullNewRemark();
              this.searchCrew();
              this.successAlert('Reservation Successfully remove');
              $('#actionRemarks').modal('hide');
            }
          });
        }
      },

      setStatus(e){
        this.reservationParams.status = e.target.value;
        this.searchCrew(1);
      },

      bookedExpired(obj) {
        if (obj.is_overStayed && !obj.is_checkOut) {
          return 'isOverstay';
        }
        return '';
      },
    },

    computed: {
      ...mapGetters(
          [
              'reservations','reservation','newRemarks','hotels','reservDtls','reservationPagination','reservationParams'
          ]
      ),

      paginationPages() {
        let pages = [];
        let currentPage = this.reservationPagination.currentPage;
        let lastPage = this.reservationPagination.lastPage;
        if (lastPage > 1) {
          let initialLimit = 1;
          if (currentPage + 5 > lastPage) {
            initialLimit = lastPage - 10;
          } else if (currentPage > 6) {
            initialLimit = currentPage - 5;
          }
          initialLimit = initialLimit < 1 ? 1 : initialLimit;
          for (let i = initialLimit; i <= initialLimit + 10; i++) {
            pages.push(i);
            if (i >= lastPage) {
              break;
            }
          }
        }
        return pages;
      },
    },

    created() {
      this.searchCrew();
      this.getCrewForReservation(this.reservationParams ? this.reservationParams : '');
      this.getHotelKeyDetails();
      this.searchBy();
    },

    mounted() {
      $(function() {
        $('[data-toggle="tooltip"]').tooltip({
          trigger: 'hover',
        });
        // $('[data-toggle="hover"]').tooltip();
      });
    },

    destroyed() {
      // this.setNullReservations();
      this.setParamsNull();
      this.setNullReservation();
      this.setNullHotels();
      this.setReservationParamsNull();
    },

  };
</script>

<style scoped>
    .btn-xsm, .btn-group-xsm > .btn {
        padding: 0.20rem 0.2rem !important;
        font-size: 0.870rem !important;
        line-height: 1 !important;
        border-radius: 0.25rem !important;
    }


    u:hover,
    u:focus {
        color: #2c82c9 !important;
        color: #4a4f54;
    }

    .btn-xsm, .btn-group-xsm > .btn {
        padding: 0.20rem 0.2rem !important;
        font-size: 0.870rem !important;
        line-height: 1 !important;
        border-radius: 0.25rem !important;
    }


    .table tbody > tr > td.vert-aligned {
        vertical-align: middle;
        padding: 0!important;
    }

    input[type=checkbox]:disabled {
        transform: scale(1.5);
    }

    .pagination li {
        margin: 0;
    }

    .h-80px {
        height: 80px;
        overflow-y: auto;
    }

    .fs-13px {
        font-size: 13px;
    }

    .modal-header * {
        font-weight: bold;
    }

</style>
